import api from '../../api';
import { TPromo } from './promo.types';

/* @TODO: change name endpoint to "punter/general/promos" when BE changed endpoint name * */
export const promosEndpoint = 'punter/general/terms';
export const queryPromos = () =>
  api.get<TPromo>(promosEndpoint).then((res) => res.data);
